<template>
    <div class="my-product-view">
      <div class="line1">
        <web-item :imgIndex="0" :item="'怪物x联盟'" :price="'已上线'"></web-item>
        <web-item :imgIndex="1" :item="'喵将传'" :price="'已上线'"></web-item>
        <web-item :imgIndex="2" :item="'魔天记'" :price="'已上线'"></web-item>
      </div>
      <div class="line1">
        <web-item :imgIndex="3" :item="'怪物x联盟2'" :price="'已上线'"></web-item>
        <web-item :imgIndex="4" :item="'怪物x联盟3'" :price="'开发中'" :disable="true"></web-item>
<!--        <web-item :imgIndex="5" :item="'学校类型网站'" :price="'1,200'"></web-item>-->
      </div>
    </div>
</template>

<script>
import WebItem from './web-item'
export default {
  name: 'myproduct',
  components: {WebItem}
}
</script>

<style scoped>
  .my-product-view{
    width: 100%;
    flex-grow: 1;
    background: url("../assets/myproduct.jpg") no-repeat fixed top;
    background-size: cover;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }
  .line1{
    margin-top: 5rem;
    width: 80%;
    flex-direction: row;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/myproduct.vue